<template>
  <v-container fluid class=" justify-start align-start " style="height: 100%">
    <v-row>
      <v-col cols="12" md="6">
        <v-toolbar-title>
          {{ $ml.get("membersTitle") }}
        </v-toolbar-title>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-end p-4">
        <v-dialog
          :retain-focus="false"
          persistent
          v-model="dialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mx-2" v-on="on">{{
              $ml.get("membersAddButton")
            }}</v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ $ml.get("membersAddTitle") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-form ref="form" v-model="valid" :lazy-validation="true">
                      <v-text-field
                        :label="$ml.get('formEmailLabel')"
                        name="email"
                        prepend-icon="mdi-account"
                        type="email"
                        v-model="email"
                        :rules="emailRules"
                      />
                    </v-form>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="onCloseHandler">{{
                $ml.get("formCancelButton")
              }}</v-btn>
              <v-btn color="blue darken-1" text @click="onAddHandler">{{
                $ml.get("formAddButton")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              {{ $ml.get("membersHeaderUsername") }}
            </th>
            <th class="text-left">
              {{ $ml.get("membersHeaderEmail") }}
            </th>
            <th class="text-left">
              {{ $ml.get("membersHeaderDateCreate") }}
            </th>
            <th class="text-left"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in members" :key="item.id">
            <td>
              <span>{{ item.user ? item.user.name : "-" }}</span>
            </td>
            <td>
              <span>{{ item.user ? item.user.email : item.email }}</span>
            </td>
            <td>
              <span>{{ item.date_joined_str }}</span>
            </td>
            <td>
              <v-btn color="red" small dark @click="deleteMember(item)">{{
                $ml.get("tableDeleteButton")
              }}</v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
import orgApi from "@/modules/Organizations/api/";
import _ from "lodash";
import moment from "moment";
export default {
  name: "Members",
  mounted() {
    this.searchMethod();
  },
  data() {
    return {
      search: "",
      valid: false,
      members: [],
      membersTotal: 0,
      dialog: false,
      email: "",
      emailRules: [
        v => !!v || this.$ml.get("formRuleRequired"),
        v => /.+@.+\..+/.test(v) || this.$ml.get("formRuleEmailErr")
      ]
    };
  },
  watch: {
    searchedCompany() {
      this.searchMethod();
    }
  },
  computed: {
    searchedCompany() {
      return this.$store.getters["navigation/selectedCompanyObject"];
    }
  },
  methods: {
    searchMethod() {
      orgApi.getOrganizationsMembers(this.searchedCompany.id).then(response => {
        this.members = response.data;
        _.forEach(this.members, item => {
          item.date_joined_str = moment(item.date_joined).format(
            this.$ml.get("dateTimeFormat")
          );
        });
        this.membersTotal = this.members.length;
      });
    },
    tableClickHandler(event) {
      return null;
    },
    onCloseHandler() {
      this.dialog = false;
      setTimeout(() => {
        this.email = "";
      }, 300);
    },
    onAddHandler() {
      if (this.$refs.form.validate()) {
        const credentials = {
          email: this.email
        };
        orgApi
          .inviteMember(this.searchedCompany.id, credentials)
          .then(response => {
            if (response.status === 201) {
              this.$message.success(
                this.$ml.get("membersRegistrationSuccessMsg")
              );
            } else {
              this.$message.success(this.$ml.get("membersAddSuccessMsg"));
            }
            this.onCloseHandler();
            this.searchMethod();
          })
          .catch(error => {
            const message = _.get(error, "response.data.detail");
            if (message) {
              this.$message.error(message);
            }
          });
      }
    },
    deleteMember(item) {
      if (confirm(this.$ml.get("membersDeleteLabel"))) {
        orgApi
          .deleteMember(this.searchedCompany.id, item.id)
          .then(() => {
            this.searchMethod();
          })
          .catch(error => {
            const message = _.get(error, "response.data.detail");
            if (message) {
              this.$message.error(message);
            }
          });
      }
    }
  }
};
</script>

<style scoped></style>
